import React, { useState } from 'react'
import Title from '../layouts/Title';
import Education from './Education';
import Skills from './Skills';
import Experience from "./Experience"
import { motion } from 'framer-motion';

const Resume = () => {
  const [activeTab, setActiveTab] = useState("experience");

  const tabs = [
    { id: "experience", label: "Experience" },
    { id: "skills", label: "Professional Skills" },
    { id: "education", label: "Education" },
  ];

  return (
    <section id="resume" className="w-full py-8">
      <div className="flex justify-center items-center text-center mb-6">
        <Title title="Resume" des="My Experience" />
      </div>

      <div className="flex flex-wrap justify-center gap-2 mb-6">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`px-4 py-2 rounded-lg text-xs font-medium transition-all duration-300 ${
              activeTab === tab.id
                ? "text-cyan-400 border border-cyan-400/60 bg-cyan-400/5 shadow-md shadow-cyan-500/20"
                : "text-gray-400 border border-white/10 bg-white/5 hover:text-cyan-300 hover:border-cyan-400/30"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <motion.div
        key={activeTab}
        initial={{ opacity: 0, y: 15 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
      >
        {activeTab === "experience" && <Experience />}
        {activeTab === "skills" && <Skills />}
        {activeTab === "education" && <Education />}
      </motion.div>
    </section>
  );
}

export default Resume
